export enum CrmEntity {
	Contact = 'CONTACT',
	Company = 'COMPANY',
	Deal = 'DEAL',
}
